import React from 'react'

import {
  Form, 
  Row,
  Col, Checkbox,
  Button,

} from 'antd';



class EAD extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      val: false

    };

  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.submitHandlerStep({ attestation: values.attestation ? "Y" : "N" });
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    
    return (
      <div ><Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>

        <Row className='mi_main'>
          <Col sm={24}>
            <p style={{ background: '#9982821f', padding: '10px' }} >Read carefully and <b>Accept</b> to continue.</p>
            <ol>
              <li>I hereby certify that, under penalty of perjury, all of the information submitted in this application and attachments is true and complete. I am aware that submitting false information or omitting pertinent or material information in connection with this application is grounds for license revocation or denial of the license and may subject me to civil or criminal penalties.</li>
              <li>Unless provided otherwise by law or regulation of the jurisdiction , I hereby designate the Commissioner, Director or Superintendent of Insurance, or other appropriate party in each jurisdiction for which this application is made to be my agent for service of process regarding all insurance matters in the respective jurisdiction and agree that service upon the Commissioner, Director or Superintendent of Insurance, or other appropriate party of that jurisdiction is of the same legal force and validity as personal service upon myself.</li>
              <li>I further certify that I grant permission to the Commissioner, Director or Superintendent of Insurance, or other appropriate party in each jurisdiction for which this application is made to verify information with any federal, state or local government agency, current or former employer, or insurance company.</li>
              <li>I further certify that, under penalty of perjury, a) I have no child-support obligation, b) I have a child-support obligation and I am currently in compliance with that obligation, or c) I have identified my child support obligation arrearage on this application.</li>
              <li>I authorize the jurisdictions to which this application is made to give any information concerning me, as permitted by law, to any federal, state or municipal agency, or any other organization and I release the jurisdictions and any person acting on their behalf from any and all liability of whatever nature by reason of furnishing such information.</li>
              <li>I acknowledge that I understand and will comply with the insurance laws and regulations of the jurisdictions to which I am applying for licensure.</li>
              <li>For Non-Resident License Applications, I certify that I am licensed and in good standing in my home state/resident state for the lines of authority requested from the non-resident state.</li>
              <li>I hereby certify that upon request, I will furnish the jurisdiction(s) to which I am applying, certified copies of any documents attached to this application or requested by the jurisdiction(s).</li>
            </ol>
          </Col>
          <Col sm={24} style={{ textAlign: 'center' }}>
            {getFieldDecorator('attestation', {
              valuePropName: 'checked',
              initialValue: false,
            })(<Checkbox onChange={(e) => {
              this.setState({
                val: e.target.checked
              })
            }}>I Accept *</Checkbox>)}
          </Col>
         
        </Row>
        <Row className="mi_main_div">
          <Col md={24}>
            <div className="collapsepanel-footer ">
              <Button className=" ant-btn mi_button_right" style={{ float: "left", marginTop: "-20px", marginLeft: "-11px" }} onClick={() => this.props.back("step")}> Back</Button>

              <Button className=" ant-btn-primary" htmlType='submit' disabled={!this.state.val}
                style={{ float: "right", marginTop: "-20px", marginRight: "-11px" }}>
                Submit</Button> </div>
          </Col>  </Row>


      </Form>


      </div>

    )
  }
}

const NiprAttestation = Form.create()(EAD);

export default NiprAttestation;

